import { isEmpty, isArray } from './boolean';
export var implode = function implode(delimiter, arr, noEmpty) {
  if (noEmpty === void 0) {
    noEmpty = true;
  }
  return (noEmpty ? arr.filter(function (item) {
    return !isEmpty(item);
  }) : arr).join(delimiter);
};
export var range = function range(start, end, step) {
  if (step === void 0) {
    step = 1;
  }
  if (start === end) {
    return [start];
  }
  return [start].concat(range(start + step, end, step));
};
export var arrayUnique = function arrayUnique(arr) {
  if (!isArray(arr)) {
    // eslint-disable-next-line no-console
    console.error("first argument should be an array.");
    return false;
  }
  var iterator = function iterator(value, index, self) {
    return self.indexOf(value) === index;
  };
  return arr.filter(iterator);
};